import { createSelector } from 'reselect';

const selectAdminLevelCity = (state: any) => state.AdminLevelCity;


export const selectAdminLevelCityCurrentItem = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.current);

export const selectAdminLevelCityListItems = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectAdminLevelCityListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAdminLevelCityQueryItems = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.query);

export const selectAdminLevelCityCreatedItem = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.create);

export const selectAdminLevelCityUpdatedItem = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.update);

export const selectAdminLevelCityReadItem = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.read);

export const selectAdminLevelCityDeletedItem = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.delete);

export const selectAdminLevelCitySearchedItems = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.search);

export const selectAdminLevelCityItemsCount = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.count);

export const selectAdminLevelCityItemsFilter = createSelector([selectAdminLevelCity], (AdminLevelCity) => AdminLevelCity.filter);